import initialState from '../initialstate';
import * as actions from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import {currentResource} from '../../util/utils';

export default function HelixProjectGLAAccountdataReducer(state = initialState.glAccountStatus, action) {
	switch (action.type) {
		case actions.GET_GL_ACCOUNT_STATUS_BY_PROJECTID:
			let newState = _.cloneDeep(state);
			newState.errors = state.errors ? _.cloneDeep(state.errors) : [];

			if (action.error && action.meta?.payload) {
				let errorMessage = null;

				if (
					(action.error?.response?.status === HttpStatusCodes.BadRequest ||
						action.error?.response?.status === HttpStatusCodes.NotFound) &&
					action.error?.response?.data?.code &&
					action.error?.response?.data?.message
				) {
					const errorCode = action.error.response.data.code;
					const message = action.error?.response?.data?.message;
					const resouceLabel = currentResource.AnalyzerHelixErrors[errorCode];
					if (resouceLabel) {
						errorMessage = resouceLabel;
					} else if (message) {
						errorMessage = message;
					}
				} else if (action.error?.response?.status === HttpStatusCodes.Forbidden) {
					errorMessage = currentResource.Errors[34030];
				} else {
					errorMessage = currentResource.labels.helixAnalyzerGLAConnectionErrorMessage;
				}
				if (errorMessage) {
					const errorExists = newState.errors?.some(
						(error) => error.SlotId === action.meta.payload && error.errorMessage === errorMessage
					);
					if (!errorExists) {
						const errorObject = {
							SlotId: action.meta.payload,
							errorMessage: errorMessage
						};
						newState.errors.push(errorObject);
					}
				}
				return newState;
			} else {
				const exists = newState?.some((item) => item?.SlotId === action.meta.payload);
				if (!exists) {
					let item = action.response;
					item.SlotId = action.meta.payload;
					newState.push(item);
					return newState;
				}
			}
			return state;
		default:
			return state;
	}
}
